import { createReducer } from '../utils';
import {
  CURRENT_ITEM_SUCCESS,
  CURRENT_ITEM_REQUEST,
  SET_CURRENT_ITEM,
  SET_CURRENT_ITEM_BY_SLUG,
  SET_CURRENT_ITEM_BY_FEED,
  SET_CURRENT_ITEM_BY_USERNAME,
  SET_SELECTED_ITEM,
  LIVECAM_CLICK_TRACKER, SET_IS_LIVE_STATUS,
} from '../constants';

const initialState = {
  data: {
    description: "",
    best_viewing_start_time: null,
    best_viewing_end_time: null,
    established_date: null,
    latlong: null,
    cam_group: {
      id: null
    },
    weather: {
      current: {
        timezone: null
      }
    },
    prime_all_day: null,
    prime_all_night: null,
    animal_information: null,
    animal_information_header: null,
    is_offline: null,
    snapshot: "",
    thumbnail_large_url: "",
    user: null,
    isLive: null,
    newCommentSystem: false,
    canonical_url: '',
  },
  isFetching: false,
  selectedItem: null,
  livecamClicks: 0,
  nonPrimaryFeeds: [],
};

export default createReducer(initialState, {
  [SET_IS_LIVE_STATUS]: (state, payload) => {
    return Object.assign({}, state, {
      data: Object.assign({}, state.data, { isLive: payload }),
    });
  },
  [CURRENT_ITEM_SUCCESS]: (state, payload) => {
    return Object.assign({}, state, {
      data: payload.data,
      nonPrimaryFeeds: payload.nonPrimaryFeeds,
      isFetching: false
    });
  },
  [CURRENT_ITEM_REQUEST]: (state, payload) => {
    return Object.assign({}, state, {
      isFetching: true
    });
  },
  [SET_CURRENT_ITEM]: (state, payload) => {
    return Object.assign({}, state, {
      isFetching: true
    });
  },
  [SET_CURRENT_ITEM_BY_SLUG]: (state, payload) => {
    return Object.assign({}, state, {
      isFetching: true
    });
  },
  [SET_CURRENT_ITEM_BY_FEED]: (state, payload) => {
    return Object.assign({}, state, {
      isFetching: true
    });
  },
  [SET_CURRENT_ITEM_BY_USERNAME]: (state, payload) => {
    return Object.assign({}, state, {
      isFetching: true
    });
  },
  [SET_SELECTED_ITEM]: (state, payload) => {
    return Object.assign({}, state, {
      selectedItem: payload.selectedItem
    });
  },
  [LIVECAM_CLICK_TRACKER]: (state, payload) => {
    const { livecamClicks } = state;
    return Object.assign({}, state, {
      livecamClicks: livecamClicks + 1,
    });
  }
});
